import { Card, Col, Input, Row, Space } from 'antd';
import FormItem from 'components/form/FormItem';
import FormSwitch from 'components/form/FormSwitch';
import PermissionsList from 'containers/RolePermissions/List/PermissionsList';
import React from 'react';

const Form = () => {
  return (
    <Space direction="vertical" size={20} className="w-full mt-5">
      <Card>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <FormItem name="name" label="Role Name" required />
          </Col>
          <Col span={12}>
            <FormSwitch name="isActive" label="Active status" />
          </Col>
          <Col span={24}>
            <FormItem name="description" label="Description">
              <Input.TextArea />
            </FormItem>
          </Col>
        </Row>
      </Card>
      <PermissionsList />
    </Space>
  );
};

export default Form;
